import styled from 'styled-components';

import { AppCaption } from '@/components/AppCaption';
import { PAYWALL_NOTES } from '@/constants/campaign-notes';
import { webCampaign } from '@/modules/webCampaign';
import { LogoWithAppName } from '@/pages/Onboarding/components/LogoWithAppName';

const MainImageHeaderStyles = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
`;

export const MainImageHeader: React.FC = () => {
  const shouldRenderLogoBg = webCampaign.setup.paywallNotes.includes(
    PAYWALL_NOTES.APP_ICON_BG,
  );

  const removeDialogueReferences = webCampaign.setup.paywallNotes.includes(
    PAYWALL_NOTES.REMOVE_DIALOGUE_REFERENCES,
  );

  const hideAppCaption = webCampaign.setup.paywallNotes.includes(
    PAYWALL_NOTES.HIDE_APP_CAPTION,
  );

  if (removeDialogueReferences) {
    return null;
  }

  return (
    <MainImageHeaderStyles>
      <LogoWithAppName
        withCaption={false}
        withBg={shouldRenderLogoBg}
        variant={webCampaign.isPaywallLure() ? 'white' : 'default'}
      />
      {!hideAppCaption && (
        <AppCaption
          withBg={shouldRenderLogoBg}
          variant={webCampaign.isPaywallLure() ? 'white' : 'default'}
        />
      )}
    </MainImageHeaderStyles>
  );
};
